import React from 'react';
import { Typography, Box } from '@mui/material';
import CustomTooltip from './CustomTooltip';
const BOOK_MARK = 'https://docs.google.com/document/d'

export const DOCS_LINK = {
  "Business Entity": `${BOOK_MARK}/1rnva_9VtcUdK0a9LfdDUOiHK30by02rjamuu5G_lpcA/edit#heading=h.df50mbguny6a`,
  "Business Entity Details": `${BOOK_MARK}/1rnva_9VtcUdK0a9LfdDUOiHK30by02rjamuu5G_lpcA/edit?tab=t.0#heading=h.kp2k881zeyie`,
  "Merchant": `${BOOK_MARK}/1rnva_9VtcUdK0a9LfdDUOiHK30by02rjamuu5G_lpcA/edit#heading=h.mg4ikuokiohl`,
  "Merchant Details": `${BOOK_MARK}/1rnva_9VtcUdK0a9LfdDUOiHK30by02rjamuu5G_lpcA/edit?tab=t.0#heading=h.ji5msnjw612x`,
  "Payment Host": `${BOOK_MARK}/1rnva_9VtcUdK0a9LfdDUOiHK30by02rjamuu5G_lpcA/edit#heading=h.lpcc9klr0wcm`,
  "Payment Host Details": `${BOOK_MARK}/1rnva_9VtcUdK0a9LfdDUOiHK30by02rjamuu5G_lpcA/edit?tab=t.0#heading=h.azf7gi1wcqpn`,
  "Payment Brand": `${BOOK_MARK}/1rnva_9VtcUdK0a9LfdDUOiHK30by02rjamuu5G_lpcA/edit#heading=h.ukzd1gdqnxsj`,
  "Payment Method": `${BOOK_MARK}/1rnva_9VtcUdK0a9LfdDUOiHK30by02rjamuu5G_lpcA/edit#heading=h.xi3irkt56q10`,
  "Terminal": `${BOOK_MARK}/1rnva_9VtcUdK0a9LfdDUOiHK30by02rjamuu5G_lpcA/edit#heading=h.n259nnkhg2`,
  "Terminal Details": `${BOOK_MARK}/1rnva_9VtcUdK0a9LfdDUOiHK30by02rjamuu5G_lpcA/edit?tab=t.0#heading=h.28fzkxcpv9d`,
  "Account": `${BOOK_MARK}/1IB4fOOukjdcWcWwSwZ-K-1KKG9BXztd9V5EwnPoMfuE/edit#heading=h.df50mbguny6a`,
  "Account Details": `${BOOK_MARK}/1IB4fOOukjdcWcWwSwZ-K-1KKG9BXztd9V5EwnPoMfuE/edit?tab=t.0#heading=h.k7g9mzdmu6rx`,
  "Role Management": `${BOOK_MARK}/1IB4fOOukjdcWcWwSwZ-K-1KKG9BXztd9V5EwnPoMfuE/edit#heading=h.j4zi6no9cod0`,
  "Merchant User": `${BOOK_MARK}/1IB4fOOukjdcWcWwSwZ-K-1KKG9BXztd9V5EwnPoMfuE/edit#heading=h.iimljl9e3pqa`,
  "Merchant User Details": `${BOOK_MARK}/1IB4fOOukjdcWcWwSwZ-K-1KKG9BXztd9V5EwnPoMfuE/edit?tab=t.0#heading=h.hoog2z3ctxtk`,
  "Virtual Account": `${BOOK_MARK}/1nfRZq4MmpE1OS0sB0K4F4d00GykKQnbh-nWb8XXofY8/edit?tab=t.0#heading=h.5uxwicb80tac`,
  "Virtual Account Details": `${BOOK_MARK}/1nfRZq4MmpE1OS0sB0K4F4d00GykKQnbh-nWb8XXofY8/edit?tab=t.0#heading=h.ccw4uiymlm5q`,
  "Pending Transfer": `${BOOK_MARK}/1nfRZq4MmpE1OS0sB0K4F4d00GykKQnbh-nWb8XXofY8/edit?tab=t.0#heading=h.yk1dbcyjzeeo`,
  "Completed Transfer": `${BOOK_MARK}/1nfRZq4MmpE1OS0sB0K4F4d00GykKQnbh-nWb8XXofY8/edit?tab=t.0#heading=h.sd2pgtm1adr4`,
  "Mismatched": `${BOOK_MARK}/1gw65qf9OT2m-WKJJdfGZeLEx9btcWpO29k9ha_Yu4NU/edit#heading=h.nygxm7y2r6pi`,
  "Reconciled": `${BOOK_MARK}/1gw65qf9OT2m-WKJJdfGZeLEx9btcWpO29k9ha_Yu4NU/edit#heading=h.3nmbqpob6xf0`,
  "Chargeback": `${BOOK_MARK}/1gw65qf9OT2m-WKJJdfGZeLEx9btcWpO29k9ha_Yu4NU/edit#heading=h.1awuwj45xuqo`,
  "Settlement Pending": `${BOOK_MARK}/1gw65qf9OT2m-WKJJdfGZeLEx9btcWpO29k9ha_Yu4NU/edit#heading=h.b4b8tk7ihrs5`,
  "Settlement Approved": `${BOOK_MARK}/1gw65qf9OT2m-WKJJdfGZeLEx9btcWpO29k9ha_Yu4NU/edit#heading=h.3rczled89bf0`,
  "Settlement Rejected": `${BOOK_MARK}/1gw65qf9OT2m-WKJJdfGZeLEx9btcWpO29k9ha_Yu4NU/edit#heading=h.tuyiczj0b7ts`,
  "Security Deposit": `${BOOK_MARK}/1gw65qf9OT2m-WKJJdfGZeLEx9btcWpO29k9ha_Yu4NU/edit#heading=h.bb9k1ska7740`,
  "Report": `${BOOK_MARK}/1gw65qf9OT2m-WKJJdfGZeLEx9btcWpO29k9ha_Yu4NU/edit#heading=h.gmma6onmoh0j`,
  "Merchant Payout Info": `${BOOK_MARK}/1gw65qf9OT2m-WKJJdfGZeLEx9btcWpO29k9ha_Yu4NU/edit#heading=h.cdqpqj3m49ia`,
  "Transactions": `${BOOK_MARK}/1PvokrJfCedEJYJRVQOFulxT18ueO_BYgWNcWjHy95Q4/edit#heading=h.5uxwicb80tac`,
  "PayNow Descriptor": `${BOOK_MARK}/1rnva_9VtcUdK0a9LfdDUOiHK30by02rjamuu5G_lpcA/edit#heading=h.t9xifxeh0orp`,
  "Data File Generation": `${BOOK_MARK}/1rnva_9VtcUdK0a9LfdDUOiHK30by02rjamuu5G_lpcA/edit#heading=h.3ylh2nbfq4s`,
  "Payout pipeline manual": `${BOOK_MARK}/1gw65qf9OT2m-WKJJdfGZeLEx9btcWpO29k9ha_Yu4NU/edit#heading=h.xtbxzmseawve`,
  "Payout pipeline tracker": `${BOOK_MARK}/1gw65qf9OT2m-WKJJdfGZeLEx9btcWpO29k9ha_Yu4NU/edit#heading=h.og6fic217t0s`,
  "Payout Ingestor": `${BOOK_MARK}/1gw65qf9OT2m-WKJJdfGZeLEx9btcWpO29k9ha_Yu4NU/edit?tab=t.0#heading=h.7g7rzolr8m42`,
  "Payout Reconciliation": `${BOOK_MARK}/1gw65qf9OT2m-WKJJdfGZeLEx9btcWpO29k9ha_Yu4NU/edit?tab=t.0#heading=h.2ojw2gubpq7x`,
  "Payout Settlement": `${BOOK_MARK}/1gw65qf9OT2m-WKJJdfGZeLEx9btcWpO29k9ha_Yu4NU/edit?tab=t.0#heading=h.tuab844vslzv`,
  "Onboarding": `${BOOK_MARK}/1UFnEYoxNeXVaQ2qaS91zA-J-0mrgiub9nrNhpQpH9lA`,
  "Guide&Reference": `${BOOK_MARK}/1emCgcXIIcac51P5h9L3hZejTvNSnX3rozQsZNnidoIw`,
  "Import Data": `${BOOK_MARK}/1gw65qf9OT2m-WKJJdfGZeLEx9btcWpO29k9ha_Yu4NU/edit?tab=t.0#heading=h.ywxhdxcvt8at`,
  "Exchange Rates": `${BOOK_MARK}/13lrmyk9BLJVwVgXynAPDJUsNqPbytMirLthhEPzPiAc/edit?pli=1&tab=t.0#heading=h.554mrenfh236`,
}


const tooltipContent = (title, description) => {
  // const link = DOCS_LINK[title]

  return (
    <Box>
      {description && <Typography component="li">{description}</Typography>}
      {/* {link && <Typography component="li">Click <a href={link} target="_blank" rel="noreferrer">here</a> to see details.</Typography>} */}
    </Box>
  )
};

const HeaderHelpPage = ({ title, description, isShowLink = true, variant = "h3", mb = 3 }) => {
  return (
    <Box sx={{ mb, display: "flex", alignItems: "center" }}>
      <Typography variant={variant}>{title}</Typography>
      { isShowLink && description && <CustomTooltip content={tooltipContent(title, description)} />}
    </Box>
  );
};

export default HeaderHelpPage;